/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2018, Zumper
 * @description user selectors
 */

import { checkLoggedIn, getUser } from '@zcode-ui/web-zumper-global-state'

export const selectIsLoggedIn = checkLoggedIn

export const selectUser = getUser
